import { FunctionComponent } from "react";
import { useLocation } from "react-router";
import { observer } from "mobx-react-lite";

import { classNames } from "primereact/utils";

import { ContentComponent, ContentSidebar, FooterComponent, NavbarComponent, OverlaySidebar } from "..";
import { useStore } from "../../../stores/StoreContext";
import { GlobalErrorMessages } from "../../Shared/GlobalErrorMessages";
import { GlobalPrimeReactDefinitions } from "../../Shared/GlobalPrimeReactDefinitions/GlobalPrimeReactDefinitions";

import "./Main.scss";

import { RouteConstants } from "../../../models/enums/route-constants.enum";
import { AiUsageWarning } from "../../Shared/Components";

const RawMainComponent: FunctionComponent = () => {
  const { sidebarStore, breakpointStore, navigationStore } = useStore();
  const location = useLocation();

  const shouldShowAiWarning =
    location.pathname.startsWith(`/${RouteConstants.LandingPage}`) ||
    location.pathname.startsWith(`/${RouteConstants.Ai}`);

  const aside = (
    <aside
      className={classNames("sidebar-container", {
        "is-overlay-sidebar-active": sidebarStore.isOverlaySidebar(breakpointStore.device),
      })}
    >
      {sidebarStore.isOverlaySidebar(breakpointStore.device) ? <OverlaySidebar /> : <ContentSidebar />}
    </aside>
  );

  const main = (
    <main
      className={classNames("page-content-area", {
        "is-overlay-sidebar-active": sidebarStore.isOverlaySidebar(breakpointStore.device),
        "is-sidebar-collapsed": sidebarStore.isCollapsed,
      })}
    >
      <div className="main-container">
        <section className="navbar-area">
          <NavbarComponent />
        </section>

        <section className="content-area">
          <GlobalErrorMessages>
            {content => {
              return <div className="global-errors-container">{content}</div>;
            }}
          </GlobalErrorMessages>

          <GlobalPrimeReactDefinitions />

          <ContentComponent />

          {!!shouldShowAiWarning && <AiUsageWarning type="aiWarning" />}
        </section>
      </div>

      {!!navigationStore.currentActiveMenuItem?.showFooter && (
        <footer className="footer-area">
          <FooterComponent />
        </footer>
      )}
    </main>
  );

  return (
    <div className="page-container">
      {aside}

      {main}
    </div>
  );
};

export const MainComponent = observer(RawMainComponent);
